"use client";

import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Color = ({ selectedColor, setSelectedColor, colors }) => {
  const isSelected = (color) => selectedColor?.name === color?.name;

  const handleColorClick = (color) => {
    if (selectedColor?.name === color.name) return;
    setSelectedColor(color);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedColor("");
  };
  function formatHexColor(color) {
    if (!color) return ""; // если пусто, вернуть пустую строку
    color = color.trim(); // убрать лишние пробелы
    return color.startsWith("#") ? color : `#${color}`;
  }

  return (
    <Box
      sx={{
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "12px",
        px: 2,
        py: 0.6,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "fit-content",
      }}
    >
      <Typography variant="body1">Колір:</Typography>

      {colors?.map((color) => (
        <Box
          key={color.name}
          onClick={() => handleColorClick(color)}
          sx={{
            width: 20,
            height: 20,
            borderRadius: "2px",
            backgroundColor: formatHexColor(color?.hex),
            border: isSelected(color?.name)
              ? "2px solid white"
              : "2px solid transparent",
            cursor: "pointer",
            position: "relative",
            transition: "0.2s",
          }}
        >
          {isSelected(color) && (
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                padding: 0,
              }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default Color;
